import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-circle',
  templateUrl: './image-circle.component.html'  
})
export class ImageCircleComponent implements OnInit {

  isLoaded: boolean = false;
  @Input() imageSrc: any;
  @Input() width: number = 35;
  @Input() height: number = 35;
  @Input() hasBorder: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }
  loadImage() {
    this.isLoaded = true;
  }

}
